/**
 * HOME PANEL — the scroll driver's ADAPTER (Kyle dictation, 2026-08-04).
 *
 * The effect itself is in eg-scroll-sweep.js and is shared with the built line
 * (sections/eg-home-builtline.liquid). This file is the whole of what is
 * specific to THIS panel: which element is the track, which element is the
 * stanza, which lines get split, and which custom properties and attributes the
 * driver writes.
 *
 * WHY THE NAMES STAY `--eg-hp-*` RATHER THAN BECOMING GENERIC. The panel's
 * tokens, its design-panel dials (snippets/eg-design-panel.liquid) and
 * tests/home-scroll-contract.js all name this namespace, and the namespace is
 * also what keeps dialling this panel from moving the closing one. The driver
 * is name-agnostic precisely so both panels can keep their own.
 *
 * THIS PANEL HAS ONE STANZA, so it asks for no group numbering: the whole
 * sentence sweeps once, left to right through its three lines, and there is no
 * hand-off to choreograph. The closing panel has two and passes groupIndex /
 * groupCount as well.
 *
 * FAIL-VISIBLE, and that behaviour lives in the driver: `data-eg-hp-ready` is
 * only set once the split succeeds, so if this never runs the CSS motion rules
 * never match and the sentence renders in its finished state (visible, Clay) —
 * the same state --eg-hp-p's committed default of 1 produces.
 */
(function () {
  if (!window.EgScrollSweep) return;

  window.EgScrollSweep.mount({
    /* THE TALL TRACK, not the sticky panel inside it — see the driver's
       progress() for why measuring the sticky child would read zero. */
    host: '.eg-homepanel-host',
    group: '[data-eg-hp-copy]',
    line: '[data-eg-hp-line]',

    /* Written per frame on the host; 0 the moment the panel finishes covering
       the hero, 1 at the end of the track. */
    progress: '--eg-hp-p',
    /* Written once per character span / once on the paragraph. */
    index: '--eg-hp-i',
    count: '--eg-hp-n',

    ready: 'data-eg-hp-ready',
    arrived: 'data-eg-hp-arrived',

    /* The split wrapper and the characters are pure carriers and stay
       `display: inline` — see section-eg-home-panel.css. */
    inkClass: 'eg-homepanel__ink',
    charClass: 'eg-homepanel__char',
  });
})();
